/**
 * Gallery Carousel Component
 * 使用 Swiper.js 实现的图片轮播组件
 */

class GalleryCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;
  }

  connectedCallback() {
    // 等待 Swiper 库加载
    this.loadSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  async loadSwiper() {
    // 检查 Swiper 是否已加载
    if (typeof Swiper !== 'undefined') {
      this.initSwiper();
      return;
    }

    // 加载 Swiper CSS
    if (!document.querySelector('#swiper-css')) {
      const swiperCSS = document.createElement('link');
      swiperCSS.id = 'swiper-css';
      swiperCSS.rel = 'stylesheet';
      swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(swiperCSS);
    }

    // 加载 Swiper JS
    if (!document.querySelector('#swiper-js')) {
      const swiperJS = document.createElement('script');
      swiperJS.id = 'swiper-js';
      swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperJS.onload = () => {
        this.initSwiper();
      };
      document.head.appendChild(swiperJS);
    } else {
      // 如果脚本已存在但还未加载完成，等待加载
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          this.initSwiper();
        }
      }, 100);
      
      // 10秒超时保护
      setTimeout(() => {
        clearInterval(checkSwiper);
      }, 10000);
    }
  }

  initSwiper() {
    const swiperElement = this.querySelector('.gallery-carousel__swiper');
    if (!swiperElement) return;

    const prevButton = this.querySelector('.gallery-carousel__button--prev');
    const nextButton = this.querySelector('.gallery-carousel__button--next');
    const pagination = this.querySelector('.gallery-carousel__pagination');

    // 配置选项
    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: 45,
      centeredSlides: true,
      loop: true,
      speed: 600,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      pagination: {
        el: pagination,
        clickable: true,
        dynamicBullets: false,
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
          slidesPerView: 'auto',
        },
        750: {
          spaceBetween: 45,
          slidesPerView: 'auto',
        },
      },
    };

    // 如果启用自动播放
    if (this.autoplay) {
      swiperConfig.autoplay = {
        delay: this.autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    // 初始化 Swiper
    try {
      this.swiper = new Swiper(swiperElement, swiperConfig);

      // 添加事件监听
      this.swiper.on('slideChange', () => {
        this.handleSlideChange();
      });

      // 鼠标悬停暂停自动播放
      if (this.autoplay) {
        swiperElement.addEventListener('mouseenter', () => {
          if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.stop();
          }
        });

        swiperElement.addEventListener('mouseleave', () => {
          if (this.swiper && this.swiper.autoplay) {
            this.swiper.autoplay.start();
          }
        });
      }
    } catch (error) {
      console.error('Failed to initialize Swiper:', error);
    }
  }

  handleSlideChange() {
    // 可以在这里添加幻灯片切换时的自定义逻辑
    const event = new CustomEvent('gallery-carousel:change', {
      detail: {
        activeIndex: this.swiper.activeIndex,
        realIndex: this.swiper.realIndex,
      },
    });
    this.dispatchEvent(event);
  }
}

// 注册自定义元素
if (!customElements.get('gallery-carousel')) {
  customElements.define('gallery-carousel', GalleryCarousel);
}

